var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_931_25959)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.887 14.0454C21.887 18.3879 18.3545 21.9204 14.012 21.9204C10.799 21.9204 7.93696 19.9989 6.72027 17.0255C6.60271 16.7375 6.74052 16.409 7.02796 16.2915C7.31483 16.1745 7.6439 16.3123 7.76146 16.5992C8.80433 19.1484 11.2574 20.7954 14.0114 20.7954C17.7335 20.7954 20.7614 17.7675 20.7614 14.0454C20.7614 10.3233 17.7335 7.29541 14.0114 7.29541C11.2523 7.29541 8.80883 8.94972 7.77215 11.4641L8.04777 11.2115C8.27671 11.0017 8.63277 11.0175 8.84258 11.2464C9.0524 11.4753 9.03721 11.8314 8.80771 12.0412L7.31258 13.412C7.20796 13.5077 7.07183 13.56 6.93233 13.56C6.89915 13.56 6.86652 13.5572 6.83333 13.551C6.66065 13.52 6.51215 13.4109 6.43227 13.2551L5.61777 11.6733C5.47546 11.3972 5.58402 11.058 5.86021 10.9157C6.13696 10.7711 6.47558 10.8813 6.6179 11.1581L6.65783 11.2357C7.8194 8.19147 10.7213 6.17041 14.012 6.17041C18.3545 6.17041 21.887 9.70291 21.887 14.0454ZM8.93765 13.9998C8.93765 11.2037 11.204 8.93735 14.0001 8.93735C16.7963 8.93735 19.0626 11.2037 19.0626 13.9998C19.0626 16.796 16.7963 19.0623 14.0001 19.0623C11.204 19.0623 8.93765 16.796 8.93765 13.9998ZM13.4376 13.9998C13.4376 14.1765 13.5209 14.3435 13.6626 14.4498L15.9126 16.1373C16.0139 16.2133 16.1326 16.2498 16.2496 16.2498C16.4206 16.2498 16.5893 16.1722 16.7001 16.0248C16.8869 15.7768 16.8363 15.4241 16.5876 15.2379L14.5626 13.7192V11.1879C14.5626 10.8768 14.3106 10.6254 14.0001 10.6254C13.6896 10.6254 13.4376 10.8768 13.4376 11.1879V13.9998Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_931_25959",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 29.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareHistory);
export default __webpack_public_path__ + "static/media/share-history.28c05d8747e1c316234d181c610cd189.svg";
export { ForwardRef as ReactComponent };